import type { ClientContext } from "../../../models/eplex/ClientContext";

/**
 * Опознание пользователя для кода, который читает `_user` из localStorage.
 *
 * На единой авторизации данных о человеке в браузере нет вовсе: в токене намеренно
 * только личность, а токен ещё и в HttpOnly-куке. При этом по `_user` живёт заметная
 * часть кабинета — ключи сохранённого состояния (вкладки проценки, цели подбора,
 * настройки плагинов) и определение текущего профиля в биллинге.
 *
 * Поэтому запись остаётся, но наполняется из контекста, полученного от бэкенда, а не
 * из разбора токена. Опасным в localStorage был ТОКЕН — им подменялась личность
 * (CAB-641), — а не имя с почтой: их подделка ничего не открывает, бэкенд решает по
 * куке.
 *
 * Перезаписываем на каждой загрузке контекста: устаревшая запись прошлого аккаунта
 * иначе показывала бы чужое имя.
 */
const STORAGE_KEY = "_user";

export interface LegacyUserCache {
  email: string;
  name: string;
  lastName: string;
  avatarUrl: string;
  profileId?: number;
  signalHash?: string | null;
}

const AVATAR_URL = "./icons/Posetitel-2x.svg";

export function syncLegacyUserCache(context: ClientContext): void {
  const cache: LegacyUserCache = {
    email: context.email ?? "",
    name: context.name,
    // Фамилия отдельным полем не приходит: LH держит имя профиля одной строкой
    lastName: "",
    avatarUrl: AVATAR_URL,
    signalHash: context.signalHash,
  };

  if (context.profileId !== null) {
    cache.profileId = context.profileId;
  }

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(cache));
  } catch {
    // приватный режим может запрещать запись: тогда сохранённое состояние будет
    // общим на браузер, но кабинет работает
  }
}

export function clearLegacyUserCache(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // см. syncLegacyUserCache
  }
}
